export default function ({ app, $axios, redirect }) {
    $axios.onRequest(config => {
        $axios.defaults.headers.common['Accept-Language'] = app.i18n.locale;
        const isFarmacie = app.store.getters['global/getIsFarmacie'];

        return config;
    });

    $axios.onError(async error => {
        // const code = parseInt(error.response && error.response.status);
        // const isFarmacie = app.store.getters['global/getIsFarmacie'];

        // if (code === 401 && isFarmacie) {
        //     const isTokenRefreshed = await app.mixins[0].methods.refreshToken();
        //
        //     if (isTokenRefreshed) {
        //         const originalRequest = error.config;
        //         originalRequest.headers['Authorization'] = `Bearer ${app.$cookies.get('token')}`;
        //         // return $axios(originalRequest);
        //     } else {
        //         await app.mixins[0].methods.removeSession();
        //         if (!app.$cookies.get('token')) {
        //             // await app.store.dispatch('auth/setIsOpen', true);
        //             redirect('/');
        //         }
        //         return Promise.reject(error);
        //     }
        // }

        // THIS CODE IS USELESS, CAUSE PATH /400 WILL BE REDIRECTED AFTER ERROR REQUEST TO SHORT LINK
        // if (code === 400 || code === 404) {
        //   redirect('/error')
        // }

        return Promise.reject(error); // !!! Promise return is required for try catch construction handling
    });
}
